export default __webpack_public_path__ + "static/media/home-travel-agency-slider-img01.533e3730.jpg";